var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      top: "15%",
      title: _vm.title,
      visible: _vm.dialogVisible,
      width: "370px",
      "append-to-body": "",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      "status-icon": "",
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "赠送数量",
      prop: "angleOfAffinityNum"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: _vm.disabled,
      autocomplete: "off"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.save();
      }
    },
    model: {
      value: _vm.form.angleOfAffinityNum,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "angleOfAffinityNum", $$v);
      },
      expression: "form.angleOfAffinityNum"
    }
  })], 1)], 1), _c("div", {
    staticClass: "bottomDiv"
  }, [_c("el-button", {
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("关闭")]), _c("el-button", {
    attrs: {
      disabled: _vm.disabled,
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };